import http from '@/util/http';

export default {

    getAppliedServices() {
        return http.get('FunctionList/api/getAppliedServices');
    },
}



// WEBPACK FOOTER //
// ./src/api/functionList/functionListApi.js